import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Icon } from 'antd';

const ActionButtonGroup = ({ saveEditFolder, cancel }) => (
  <div className="pt-md pl-md pb-md">
    <Button className="email-theme-btn mr-md" onClick={saveEditFolder}>
      <Icon type="save" />
      <FormattedMessage id="page.emailTemplates.save" />
    </Button>
    <Button onClick={cancel}>
      <Icon type="close" />
      <FormattedMessage id="page.emailTemplates.cancel" />
    </Button>
  </div>
);


export default ActionButtonGroup;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/ActionButtonGroup.js